var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { funcoesPDF } from "@monorepo-web/pdf-generator";
import Grid from "@mui/material/Grid";
import CardsResumoCarteira from ".";
import { useEffect, useRef } from "react";
export default function CardsResumoCarteiraPDF(props) {
    const { id = "Cards", data, sendComponent, config, layout, replaceLabelCards, moneyPrefix } = props;
    function createComponentPDF(element) {
        return __awaiter(this, void 0, void 0, function* () {
            const cardsElement = {
                element,
                x: 10,
                scale: 0.2,
                windowWidth: 1300,
                windowHeight: 100,
                marginBottom: 25
            };
            const component = funcoesPDF.gerarHTML(config, cardsElement);
            sendComponent(id, component);
        });
    }
    const cardsRef = useRef(null);
    useEffect(() => {
        if (cardsRef.current) {
            createComponentPDF(cardsRef.current);
        }
    }, [cardsRef.current]);
    return (_jsx(Grid, Object.assign({ container: true, columns: 1, ref: cardsRef, style: {
            fontFamily: 'Roboto-Bold, Roboto-Regular',
            letterSpacing: '0.03em',
            overflow: 'visible',
            width: '950px'
        } }, { children: _jsx(CardsResumoCarteira, { info: data, dispatchPDF: true, layout: layout, replaceLabelCards: replaceLabelCards, moneyPrefix: moneyPrefix }) })));
}
